var React = require('react');

function Trousse (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"x":"2.5","y":"7","width":"19","height":"11","rx":"2","key":0}),React.createElement("path",{"d":"M2.5 10.5h19","key":1}),React.createElement("path",{"d":"M17 10.5v2.5a1 1 0 0 0 2 0v-2.5","key":2})]);
}

Trousse.defaultProps = {"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"};

module.exports = Trousse;

Trousse.default = Trousse;
